import React, { useEffect, useState } from "react";
import { IPagination } from "../../../types/customTypes";
import MTable from "../../../components/finance/MTable";
import { GridCellParams, GridColDef } from "@mui/x-data-grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import styled from "styled-components";
import { Box, IconButton, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { defaultPaginationModel } from "../../../utils/queryUtils";
import { useGetBasketsByFinanceIdQuery } from "../../../api/basketApi";
import { Loading } from "../../../components/finance/LoadingComponent";
import { IBasketTable, MIQuerySearchParams } from "../../../types/financeTypes";
import SimpleHeader from "../../../components/finance/SimpleHeader";
import { useFetchUserInfoQuery } from "../../../api/infoApi";
import LoadingSpinner from "../../../components/LoadingSpinner";

export const IconButtonStyled = styled(IconButton)`
  &&& {
    color: #333;
  }
`;

const BasketManagement: React.FC = () => {
  const columns: GridColDef[] = [
    { field: "supplier", type: "string", headerName: "Tedarikçi", width: 300 },
    { field: "totalInvoiceInBasket", headerName: "Sepetteki Toplam Fatura", type: "number", width: 300, align: "center", headerAlign: "center" },
    { field: "totalAmount", headerName: "Toplam Miktar", type: "number", width: 300, align: "center", headerAlign: "center" },
    { field: "hasOffer", headerName: "Teklif Var", type: "boolean", width: 100 },
    {
      headerAlign: "center",
      align: "center",
      field: "actions",
      headerName: "İşlemler",
      sortable: false,
      width: 300,
      renderCell: (params: GridCellParams) => (
        <IconButtonStyled color="primary" title="Sepet Detaylarını Görüntüle">
          <Link to={`/viewBasket/${params.row.id}/${params.row.supplier}/hasOffer/${params.row.hasOffer}`} style={{ textDecoration: "none" }}>
            <VisibilityIcon />
          </Link>
        </IconButtonStyled>
      ),
    },
  ];

  const { isLoading: isUserInfoFetchLoading, isSuccess: isUserInfoFetchSuccess, data: userDetails, refetch: refetchUserDetails } = useFetchUserInfoQuery();
  const [financeId, setFinanceId] = useState<string>("");
  const [baskets, setBaskets] = useState<IBasketTable[]>([]);
  const [paginationModel, setPaginationModel] = useState<IPagination>(defaultPaginationModel);
  const [queryParams, setQueryParams] = useState<MIQuerySearchParams>({ pageInfo: paginationModel, id: "1" });

  const { data, isSuccess, isFetching, refetch } = useGetBasketsByFinanceIdQuery(queryParams);
  
  useEffect(() => {
    if (isUserInfoFetchSuccess && userDetails && userDetails.data) {
      const teamId = userDetails.data.team_id || "";
      setFinanceId(teamId);
      setQueryParams((prevParams) => ({ ...prevParams, id: teamId }));
    }
  }, [isUserInfoFetchSuccess, userDetails]);

  useEffect(() => {
    let financeId = sessionStorage.getItem("financeId");
    if (financeId !== null) setFinanceId(financeId);
  }, []);

  useEffect(() => {
    if (financeId) {
      setQueryParams({ pageInfo: paginationModel, id: financeId });
      refetch();
    }
  }, [financeId, paginationModel, refetch]);

  useEffect(() => {
    refetchUserDetails();
  }, [refetchUserDetails]);

  useEffect(() => {
    if (isSuccess && data) {
      const tableStructure: IBasketTable[] = data.map((basket: any) => ({
        id: basket.id,
        hasOffer: basket.hasOffer,
        supplier: basket.supplier,
        totalAmount: basket.requestedTotalAmount,
        totalInvoiceInBasket: basket.total_invoices_in_basket,
      }));
      setBaskets(tableStructure);
    }
  }, [data, isSuccess]);

  return (
    <Box>
      <Grid container>
        <Grid item sm={12}>
          <SimpleHeader title="Sepet" />
          {isUserInfoFetchLoading && <LoadingSpinner />}
          {isFetching && <Loading />}
          <MTable rows={baskets} columns={columns} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BasketManagement;
